import styled from "styled-components";
export const Label = styled.label `
  font-size: ${({ theme, type }) => type === "checkbox"
    ? theme.fontTokens.font12[0]
    : theme.fontTokens.font14[0]};
  line-height: ${({ theme, type }) => type === "checkbox"
    ? theme.fontTokens.font12[1]
    : theme.fontTokens.font14[1]};
  color: ${({ theme }) => theme.colors.grey15};

  ${({ theme, type, disabledStates, isFlyout, hasError, checked, groupSelection, areCssLabelStatesDisabled, }) => `color: ${theme.colors.grey15};
    display: flex;
    align-items: center;
    cursor: pointer;
    min-height: 1.25rem;
    margin: 0 0 0 ${isFlyout ? "2.5rem" : `2.75rem`};
    p {
      margin: 0;
      padding:0;
    }

    @media (hover: hover) {
      &:hover {
        ${!disabledStates && !areCssLabelStatesDisabled
    ? `&:before {
          border: 1px solid rgba(${theme.colors.transparentBlack}, 0);
          background-color: rgba(${theme.colors.transparentBlack}, 0.08);
        }`
    : ""}


      ${!areCssLabelStatesDisabled
    ? `
              &:after {
          background-color: rgba(${theme.colors.transparentBlack}, 0);
          border: 1px solid ${hasError && !checked
        ? theme.colors.error
        : checked
            ? theme.colors.grey15
            : theme.colors.black};
        }
      `
    : ""}
      }
    }

    &:active {
      ${theme.global.disableTapHighlight}

      ${!disabledStates && !areCssLabelStatesDisabled
    ? `&:before {
            background-color: ${theme.colors.grey15};
            border: 1px solid ${theme.colors.grey15};
          }

          &:after {
            border: 1px solid ${theme.colors.grey10};
            background: transparent;
          }

          span {
            svg, svg path {
              fill: ${theme.colors.grey10};
            }
            color: ${theme.colors.grey10};
            ${type === "radio" ? `background-color: ${theme.colors.grey10};` : ""}
          }`
    : ""}
    }

    &:after {
      content: '';
      display: block;
      box-sizing: border-box;
      position: absolute;
      ${hasError && !checked
    ? `border: 1px solid ${theme.colors.error};`
    : checked || groupSelection
        ? `border: 1px solid ${theme.colors.grey15};`
        : `border: 1px solid ${theme.colors.grey10};`}
      ${type === "radio" ? "border-radius: 50%;" : ""};
      background: ${theme.colors.white};
      height: 1.5rem;
      width: 1.5rem;
      left: 0.5rem;
      top: 0.5rem;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      min-width: 2.5rem;
      min-height: 2.5rem;
      box-sizing: border-box;
      border: 1px solid rgb(${theme.colors.transparentBlack}, 0);
      ${type === "radio" ? "border-radius: 50%;" : ""};
    }`};

  @media ${({ theme }) => theme.device.touch} {
    margin: 0 0 0 ${({ isFlyout }) => (isFlyout ? "2.75rem" : `3rem`)};

    &:before {
      min-width: 2.75rem;
      min-height: 2.75rem;
    }
    &:after {
      left: 0.625rem;
      top: 0.625rem;
    }

    & > span {
      ${({ type }) => (type === "radio" ? "left: 1rem;top: 1rem;" : "")}
      ${({ type }) => type === "checkbox" ? "left: 0.875rem;top: 0.875rem;" : ""}
    }
  }
`;
